import * as React from 'react';
import { ReactElement, StatelessComponent } from 'react';

export const Spinner: StatelessComponent = (): ReactElement<{}> => (
    <div className="sk-chasing-dots">
        <div className="sk-child sk-dot1"/>
        <div className="sk-child sk-dot2"/>
    </div>
);
